const axios = require('axios');

export default async function callMeeting(tk) {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage._session_token}`
            }
        }
        const { data } = await axios.post(`${process.env.api}/call`, {
            token: tk
        }, config)
        return { data, error: null };
    } catch (error) {
        return { data: null, error: error };
    }
}